import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const GET_COUNRTIES_KEY = "birthcountries";

export interface TCountry {
  countryID: number;
  countryName?: string;
  countryCode: string;
  flagURL: string;
}

const getGetBirthCountries = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<{ countries: TCountry[] }>(
    `api/customer/birthcountries`,
    {
      params: {
        lang: languageCode,
      },
      headers: { langcode: languageCode },
    },
  );
  return response.data;
};

export const useBirthCountries = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [GET_COUNRTIES_KEY, i18n.language],
    queryFn: () => getGetBirthCountries(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
